import { rotateAccessToken } from './apiCalls'
import { DEFAULT_INAVTIVITY_THRESHOLD, DEFAULT_REFRESH_THRESHOLD } from './constants'
import { getItem, getRefreshToken, setLoginToken } from './storageUtils'

const DOCUMENT_EVENTS = [
  'mousemove', 'mousedown', 'click',
  'touchmove', 'touchstart', 'touchend',
  'keydown', 'keypress'
]
export class IdleTimer {
  constructor (onIdleTimeout, sessionExpiry, timeout = DEFAULT_INAVTIVITY_THRESHOLD) {
    this.sessionExpiryFromDb = sessionExpiry || JSON.parse(getItem('sessionExpiry'))
    this.onIdleTimeout = onIdleTimeout
    this.timeout = this.sessionExpiryFromDb ? this.sessionExpiryFromDb * 60 * 1000 : timeout
    this.timer = null
    this.active = false
    this.rotateTimer = null
    this.resetTimer = this.resetTimer.bind(this)
  }

  activate () {
    if (!this.active) { this.bindEvents() }

    this.timer = setTimeout(() => {
      this.onIdleTimeout()
      this.deactivate()
    }, this.timeout)

    if (!this.rotateTimer) {
      let refreshTokenTimer = this.sessionExpiryFromDb ? Math.ceil(this.sessionExpiryFromDb / 3) * 60 * 1000 : DEFAULT_REFRESH_THRESHOLD

      if (this.sessionExpiryFromDb <= 3) {
        refreshTokenTimer = 0.5 * 60 * 1000
      }

      this.rotateTimer = setInterval(() => {
        this.rotateToken()
      }, refreshTokenTimer)
    }
    this.active = true
  }

  deactivate () {
    if (this.active) { this.unbindEvents() }
    clearTimeout(this.timer)
    clearInterval(this.rotateTimer)
    this.active = false
  }

  resetTimer () {
    clearTimeout(this.timer)
    this.activate()
  }

  async rotateToken () {
    try {
      const refreshToken = getRefreshToken()
      const { data } = await rotateAccessToken({ refreshToken })
      // override access token here
      setLoginToken(data?.data?.accessToken)
    } catch (err) {
      console.log('Error in rotate token API call', err)
      // if any errors are there in rotate token, need to log user out
      clearInterval(this.rotateTimer)
      this.deactivate()
      this.onIdleTimeout()
    }
  }

  bindEvents () {
    window.addEventListener(
      'scroll', this.resetTimer, { capture: true, passive: true })

    window.addEventListener('load', this.resetTimer)

    DOCUMENT_EVENTS.forEach(
      eventType => document.addEventListener(eventType, this.resetTimer))
  }

  unbindEvents () {
    window.removeEventListener('scroll', this.resetTimer, { capture: true })
    window.removeEventListener('load', this.resetTimer)
    DOCUMENT_EVENTS.forEach(
      eventType => document.removeEventListener(eventType, this.resetTimer))
  }
}
